export default __webpack_public_path__ + "src/assets/Swap_Mobile.45efe103557c3cde599f2d3577dbb15c.svg";